import { URL_BASE_PLURI_CONNECT_TROCAR_SENHA } from '../constants/url';
import { APPS } from '../environments/apps';
import { CommunicationService } from './communication.service';
import { LocalStorageService } from './local-storage.service';
var ParceiroService = /** @class */ (function () {
    function ParceiroService() {
        this.localStorageService = LocalStorageService.singleton();
    }
    ParceiroService.singleton = function () {
        if (!ParceiroService.parceiroService) {
            ParceiroService.parceiroService = new ParceiroService();
        }
        return ParceiroService.parceiroService;
    };
    ParceiroService.prototype.showButtonUpdatePassword = function () {
        var usuario = this.localStorageService.getItem('usuario');
        if (!usuario) {
            return false;
        }
        if (!usuario.leitor_parc_id) {
            return true;
        }
        if (!usuario.url_alterar_senha) {
            return false;
        }
        return true;
    };
    ParceiroService.prototype.redirectToUpdatePassword = function () {
        var usuario = this.localStorageService.getItem('usuario');
        if (usuario && usuario.url_alterar_senha) {
            window.open(usuario.url_alterar_senha, '_self');
            return;
        }
        var sistAtivoToken = this.localStorageService.getSystemAtivoToken();
        var plataformaToken = APPS['plataforma'].chave_sistema;
        if (sistAtivoToken === plataformaToken) {
            window.location.href = '/plataforma/app' + URL_BASE_PLURI_CONNECT_TROCAR_SENHA;
            return;
        }
        CommunicationService.singleton().emitCustomEvent('requestChangeApp', {
            sist_token_acesso: APPS['plataforma'].chave_sistema,
            auth_url: URL_BASE_PLURI_CONNECT_TROCAR_SENHA,
            redirect_path: true
        });
    };
    ParceiroService.prototype.mountExternalLink = function (urlSistema, urlBase) {
        var token = this.localStorageService.getItem('token');
        return "".concat(urlSistema, "/").concat(urlBase, "?token=").concat(token, "&redirectTo=").concat(window.location.href.toString());
    };
    return ParceiroService;
}());
export { ParceiroService };
